import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router";
//import { OperationContext } from "../CreateOperation";
import { useStorageContainerStore } from "../store/StorageStore";
import { ColumnItem } from "../../../common/models/table";
import { Loader } from "../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { HttpStatusCode } from "axios";
import { ManifestoService } from "../../operations/core/_request";
import StorageContainerDetail from "./forms/StorageContainerDetail";
import { StorageService } from "../core/_request";
import CustomModal from "../../../common/components/Modal/CustomModal";
import CustomerRemovalForm from "./forms/CustomerRemovalForm";
import { downloadPDF } from "../../../utilities/downloadPdf";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { AiOutlineFilePdf } from "react-icons/ai";
import { FaHistory } from "react-icons/fa";
import { BsClockHistory } from "react-icons/bs";
import { MdManageHistory } from "react-icons/md";

interface StorageContainerListProps {
  storageType: string;
}

const StorageContainerList = ({ storageType }: StorageContainerListProps) => {
  // const { initialValue, refreshData } = useContext(OperationContext);

  const [isShowForm, setIsShowForm] = useState<boolean>(false);

  const {
    list: containerList,
    setList: setContainerList,
    pageState,
    actioned,
    setActioned,
    setPageState,
    totalItems,
    resetPageState,
  } = useStorageContainerStore();

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState({});

  // const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [downloadingId, setDownloadingId] = useState<string | null>(null);
  const [downloadingEirId, setDownloadingEirId] = useState<string | null>(null);
  const idPdf = (containerList as any)[0]?.["@id"]?.split("/").pop();

  const cols: ColumnItem[] = [
    {
      key: "reference",
      title: "Référence",
      dataIndex: "reference",
      searchKey: "uniqueIdentifier",
      show: true,
      searchType: "text",
    },
    {
      key: "loadFillingStatus",
      title: "Status",
      dataIndex: "loadFillingStatus",
      show: true,
      // isCanSort: true,
      nestedKey: "loadFillingStatus.id",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "containerType",
      title: "Nature",
      dataIndex: "containerType",
      show: true,
      // isCanSort: true,
      nestedKey: "containerType.containerUnit.id",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.containerUnit?.name}</span>
          </div>
        );
      },
    },
    {
      key: "containerType",
      title: "Type",
      dataIndex: "containerType",
      show: true,
      // isCanSort: true,
      nestedKey: "containerType.containerCategory.id",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.containerCategory?.name}</span>
          </div>
        );
      },
    },

    {
      key: "sealNumber",
      title: "N° Plomb",
      dataIndex: "sealNumber",
      show: true,
      // isCanSort: true,
    },
    {
      key: "tonnage",
      title: "Tonnage (T)",
      dataIndex: "tonnage",
      show: true,
      // isCanSort: true,
    },
  ];

  const isFirstRender = useRef(true);
  const location = useLocation();

  useEffect(() => {
    isFirstRender.current = true; // chaque fois qu'on revient, on reset
  }, [location.pathname]);

  useEffect(() => {
    if (isFirstRender.current) {
      const { uniqueIdentifier, ...rest } = pageState;
      setPageState({
        ...rest,
        page: 1,
        itemsPerPage: 10,
        pagination: true,
      });
      isFirstRender.current = false;
    } else {
      fetchRequest(pageState);
    }
  }, [pageState]);

  const fetchRequest = (params?: any) => {
    // Remove uniqueIdentifier only on first render
    let cleanParams = params;
    if (isFirstRender.current) {
      const { uniqueIdentifier, ...rest } = params || {};
      cleanParams = rest;
    }

    getMovement("api/container_loads", {
      ...cleanParams,
      "storageLoads.storage": id,
      "storageLoads.storageLoadState": ["IN", "RETURNED"],
    });
  };

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);

      const res = await ManifestoService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setContainerList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onFinishAction = () => {
    setIsOpenModal(false);
    fetchRequest({ page: 1 });
    setPageState({
      ...pageState,
      page: 1,
    });
  };

  const handleOpenModal = () => {
    if (!isOpenModal) {
      getStorageLoad({
        ...pageState,
        storageLoadState: "IN",
        storage: id,
        uniqueIdentifierLoad: containerList[0]?.reference,
      });
    }
    setIsOpenModal((prev: boolean) => !prev);
  };

  const getStorageLoad = async (params: any) => {
    try {
      setIsLoading(true);
      const res = await StorageService.getStorageLoadList(params);
      if (res.status === HttpStatusCode.Ok) setModalData(res?.data?.member[0]);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadControl = async (action: any) => {
    const rowData = action.row;
    try {
      const idPdf = rowData?.["@id"]
        ? rowData["@id"].split("/").pop()
        : rowData?.id;
      if (!idPdf) {
        console.error("Impossible de trouver l'ID pour cette ligne :", action);
        return;
      }
      const fileName = rowData?.reference || "Rapport";
      setDownloadingId(idPdf);
      await downloadPDF(
        `/api/container_loads/${idPdf}/EIR/pdf`,
        `${fileName}_EIR.pdf`
      );
    } finally {
      setDownloadingId(null);
    }
  };

  const handleDownloadEIR = async (action: any) => {
    const rowData = action.row;
    try {
      const idPdf = rowData?.["@id"]
        ? rowData["@id"].split("/").pop()
        : rowData?.id;
      if (!idPdf) {
        console.error("Impossible de trouver l'ID pour cette ligne :", action);
        return;
      }
      const fileName = rowData?.reference || "EIR";
      setDownloadingEirId(idPdf);
      await downloadPDF(
        `/api/container_loads/${idPdf}/EIR`,
        `${fileName}_control.pdf`
      );
    } finally {
      setDownloadingEirId(null);
    }
  };

  return (
    <div>
      <div>
        <Loader isLoading={isLoading} />
        <LFTableV3
          columns={cols}
          data={containerList}
          params={pageState}
          onAction={(record: any, actionType: ActionsKey) => {
            if (actionType === "read") {
              setActioned({ action: actionType, data: record });
              setIsShowForm(true);
            }
          }}
          isCanShow={() => true}
          onSearch={(search: any) => {
            setPageState(search);
          }}
          onSort={(sort: any) => {
            setPageState(sort);
          }}
          onResetSearch={() => {
            resetPageState();
          }}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={(e: any) => setPageState(e)}
          otherActions={[
            (rowAction) => {
              const rowData = rowAction.row;
              const rowId = rowData?.["@id"]?.split("/").pop() || rowData?.id;
              return (
                <>
                  {(!rowData?.imported && storageType!=="StoreStorage") ? (
                    <div>
                      {downloadingId === rowId ? (
                        <Spin
                          indicator={<LoadingOutlined spin />}
                          size="small"
                        />
                      ) : (
                        <AiOutlineFilePdf
                          title="Télécharger EIR"
                          onClick={() => handleDownloadControl(rowAction)}
                        />
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              );
            },
            (rowAction) => {
              const rowData = rowAction.row;
              const rowId = rowData?.["@id"]?.split("/").pop() || rowData?.id;
              return (
                <>
                  {(!rowData?.imported && storageType!=="StoreStorage") ? (
                    <div>
                      {downloadingEirId === rowId ? (
                        <Spin
                          indicator={<LoadingOutlined spin />}
                          size="small"
                        />
                      ) : (
                        <MdManageHistory  
                          title="Historique de contrôle"
                          onClick={() => handleDownloadEIR(rowAction)}
                        />
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              );
            },
          ]}
        />
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={
            actioned?.action === "read"
              ? "Détails"
              : actioned?.action === "update"
              ? "Modification"
              : "Nouvau"
          }
          width={"75%"}
        >
          <StorageContainerDetail
            {...{
              initialValue: actioned?.data,
              type: actioned?.action,
            }}
          />
        </CustomDrawer>
      ) : (
        ""
      )}

      {/* Modal section */}
      {isOpenModal && (
        <CustomModal
          isOpen={isOpenModal}
          hanldeCloseModal={handleOpenModal}
          title="Enlèvement client"
        >
          <CustomerRemovalForm
            onFinish={onFinishAction}
            initialValue={modalData}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default StorageContainerList;
